import ComingSoonCover from "@/components/ComingSoonCover";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_staff/person/alumni/$id/_profile/activity/",
)({
  component: () => <ComingSoonCover />,
});
